// Keep shared server records current without discarding forms or table selections.
export const watchLiveRefresh = (refresh, interval = 10000) => {
  const resume = () => {
    if (document.visibilityState === 'visible' && navigator.onLine) refresh();
  };
  const timer = interval ? window.setInterval(resume, interval) : null;
  window.addEventListener('focus', resume);
  window.addEventListener('online', resume);
  document.addEventListener('visibilitychange', resume);
  return () => {
    window.clearInterval(timer);
    window.removeEventListener('focus', resume);
    window.removeEventListener('online', resume);
    document.removeEventListener('visibilitychange', resume);
  };
};